$(document).ready(function() {

  /* Frontend */
  navitagionOnScroll();
  anchorGoToHash();
  triggerMenuNavigation();
  openModal();
  
  /* Buscador */
  loadModel();
  returnBattery();
});
